module.exports = __webpack_public_path__ + "static/assets/1356c921d27584f21af4b45ac751a07a.png";